// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar-container {
  height: 100vh;
  overflow-x: auto;
  border-radius: 10px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
  margin: 16px;
  display: flex;
  flex-direction: column;
}

.wide-table {
  table-layout: fixed;
  width: 100%;
  background-color: #f1f1f1;
  border-collapse: collapse;
}

.wide-table thead th {
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 2;
  border-bottom: 2px solid #ccc;
}

.day-cell {
  width: 14%;
}

.calendar-cell {
  width: 70px;
  height: 70px;
  position: relative;
}

.person-photo {
  width: 25px;
  height: 25px;
  border-radius: 50%;
}

.person-photo-large {
  width: 100px;
  height: 100px;
  border-radius: 50%;
}

.cell-content {
  position: relative;
  text-align: center;
}

.cell-buttons {
  display: none;
}

.select-button,
.remove-button {
  margin: 0 2px;
}

.table-row {
  position: relative;
}

.table-body {
  overflow-y: auto;
  height: calc(100vh - 56px);
}

.person-details {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 200px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 3; /* Ensure the details box is above other elements */
  max-height: 300px; /* Optional: restricts height of the details box */
  overflow-y: auto; /* Add scroll if content overflows */
}

.person-details img {
  width: 80px; /* Adjust size as needed */
  height: 80px;
  border-radius: 50%;
}

.person-details p {
  margin: 2px 0; /* Margin between details */
}

.cell-content:hover .person-details {
  display: flex;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Calendar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,sBAAsB;EACtB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU,EAAE,mDAAmD;EAC/D,iBAAiB,EAAE,kDAAkD;EACrE,gBAAgB,EAAE,oCAAoC;AACxD;;AAEA;EACE,WAAW,EAAE,0BAA0B;EACvC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa,EAAE,2BAA2B;AAC5C;;AAEA;EACE,aAAa;AACf","sourcesContent":[".calendar-container {\n  height: 100vh;\n  overflow-x: auto;\n  border-radius: 10px;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);\n  margin: 16px;\n  display: flex;\n  flex-direction: column;\n}\n\n.wide-table {\n  table-layout: fixed;\n  width: 100%;\n  background-color: #f1f1f1;\n  border-collapse: collapse;\n}\n\n.wide-table thead th {\n  position: sticky;\n  top: 0;\n  background-color: #fff;\n  z-index: 2;\n  border-bottom: 2px solid #ccc;\n}\n\n.day-cell {\n  width: 14%;\n}\n\n.calendar-cell {\n  width: 70px;\n  height: 70px;\n  position: relative;\n}\n\n.person-photo {\n  width: 25px;\n  height: 25px;\n  border-radius: 50%;\n}\n\n.person-photo-large {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n}\n\n.cell-content {\n  position: relative;\n  text-align: center;\n}\n\n.cell-buttons {\n  display: none;\n}\n\n.select-button,\n.remove-button {\n  margin: 0 2px;\n}\n\n.table-row {\n  position: relative;\n}\n\n.table-body {\n  overflow-y: auto;\n  height: calc(100vh - 56px);\n}\n\n.person-details {\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 200px;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  z-index: 3; /* Ensure the details box is above other elements */\n  max-height: 300px; /* Optional: restricts height of the details box */\n  overflow-y: auto; /* Add scroll if content overflows */\n}\n\n.person-details img {\n  width: 80px; /* Adjust size as needed */\n  height: 80px;\n  border-radius: 50%;\n}\n\n.person-details p {\n  margin: 2px 0; /* Margin between details */\n}\n\n.cell-content:hover .person-details {\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
